import { render } from "./AppCheckbox.vue?vue&type=template&id=ce1874b6&scoped=true"
import script from "./AppCheckbox.vue?vue&type=script&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&lang=js"

import "./AppCheckbox.vue?vue&type=style&index=0&id=ce1874b6&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce1874b6"]])

export default __exports__